(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ld-pdp-hand-compare"] && !Shopify.designMode) return;
  try {
    (function() {
    if (customElements.get('ld-homepage-hand')) return;
    class LdHomepageHand extends HTMLElement {
      setup() {
  this.slider = this.querySelector('[data-slider]');
  if (!this.slider) return;

  this.afterContainer = this.querySelector('[data-after-container]');
  this.divider = this.querySelector('[data-divider]');
  this.handle = this.querySelector('[data-handle]');
  this.isDragging = false;
  this.isAnimating = false;
  this.currentPosition = 50;
  this.hasAutoPlayed = false;
  this.isMobile = window.matchMedia('(max-width: 749px)').matches;

  this.autoplayEnabled = this.dataset.autoplay === 'true';
  this.autoplayDuration = parseFloat(this.dataset.duration) * 1000;
  this.autoplayDelay = parseFloat(this.dataset.delay) * 1000;
  this.autoplayRepeat = parseInt(this.dataset.repeat);
}

      connectedCallback() {
        if (this.ready) return;
        this.setup();
        if (!this.slider) return;
        this.ready = true;

        this.updatePosition(this.currentPosition);
        this.setupEventListeners();

        if (this.autoplayEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.setupIntersectionObserver();
        }
      }

      setupIntersectionObserver() {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasAutoPlayed) {
              this.hasAutoPlayed = true;
              setTimeout(() => {
                this.runAutoplay();
              }, this.autoplayDelay);
            }
          });
        }, {
          threshold: 0.3
        });

        observer.observe(this.slider);
      }

      async runAutoplay() {
        this.isAnimating = true;
        this.slider.classList.add('is-animating');

        const sequence = [15, 85, 15, 50];
        const duration = this.autoplayDuration / sequence.length;

        for (let repeat = 0; repeat < this.autoplayRepeat; repeat++) {
          for (let i = 0; i < sequence.length; i++) {
            await this.animateToPosition(sequence[i], duration);
          }
        }

        this.isAnimating = false;
        this.slider.classList.remove('is-animating');
      }

      animateToPosition(targetPosition, duration) {
        return new Promise((resolve) => {
          const startPosition = this.currentPosition;
          const distance = targetPosition - startPosition;
          const startTime = performance.now();

          const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeProgress = this.easeInOutCubic(progress);
            const newPosition = startPosition + (distance * easeProgress);

            this.updatePosition(newPosition);

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              this.currentPosition = targetPosition;
              resolve();
            }
          };

          requestAnimationFrame(animate);
        });
      }

      easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      setupEventListeners() {
  this.slider.addEventListener('mousedown', this.handleStart.bind(this));
  document.addEventListener('mousemove', this.handleMove.bind(this));
  document.addEventListener('mouseup', this.handleEnd.bind(this));
  this.slider.addEventListener('click', this.handleClick.bind(this));

  this.handle.addEventListener('touchstart', this.handleStart.bind(this), { passive: false });
  document.addEventListener('touchmove', this.handleMove.bind(this), { passive: false });
  document.addEventListener('touchend', this.handleEnd.bind(this));

  window.addEventListener('resize', () => {
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
  });
}

      handleStart(e) {
  if (this.isAnimating) return;

  if (this.isMobile) {
    const startedFromHandle = this.handle.contains(e.target);
    if (!startedFromHandle) return;

    e.preventDefault();
    this.isDragging = true;
    return;
  }

  this.isDragging = true;
  this.updatePositionFromEvent(e);
}

      handleMove(e) {
        if (!this.isDragging || this.isAnimating) return;
        e.preventDefault();
        this.updatePositionFromEvent(e);
      }

      handleEnd() {
        this.isDragging = false;
      }

      handleClick(e) {
  if (this.isAnimating) return;
  if (this.isMobile) return;

  this.updatePositionFromEvent(e);
}

      updatePositionFromEvent(e) {
        const rect = this.slider.getBoundingClientRect();
        const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const x = clientX - rect.left;
        const percentage = (x / rect.width) * 100;
        const clampedPercentage = Math.max(0, Math.min(100, percentage));

        this.currentPosition = clampedPercentage;
        this.updatePosition(clampedPercentage);
      }

      updatePosition(percentage) {
        const clampedPercentage = Math.max(0, Math.min(100, percentage));

        this.afterContainer.style.clipPath = `inset(0 ${100 - clampedPercentage}% 0 0)`;
        this.divider.style.left = `${clampedPercentage}%`;
        this.handle.style.left = `${clampedPercentage}%`;
      }
    }

    customElements.define('ld-homepage-hand', LdHomepageHand);
  })();
  } catch(e) { console.error(e); }
})();

})();
